import React from 'react'
import { ConfigState } from '../types'

export const ConfigContext = React.createContext<ConfigState>({
  mainConfigLoaded: true,
  systemAvailabilityConfigLoaded: false,
  config: {},
  loadSystemAvailabilityConfig: () => {},
})
